import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { notification } from 'antd';
import { AppContext } from 'App.context';
import ContentBox from 'Components/common/ContentBox/ContentBox';
import DefaultLayout from 'Components/DefaultLayout/DefaultLayout';
import paymentMethodConfiguredRequest from 'utils/networking/api/auth/paymentMethodConfigured.service';
import AccountOwnerDetail from './AccountOwnerDetail/AccountOwnerDetail';
import ChangePasswordForm from './ChangePasswordForm/ChangePasswordForm';
import PaymentMethods from './PaymentMethods/PaymentMethods';
import AccountFunctionalities from './AccountFunctionalities/AccountFunctionalities';
import NewHotelSelector from 'Components/common/HotelSelector_new/NewHotelSelector';

export default function AccountDetail() {
  const {
    appState,
    appActions: { translate, getPaymentMethods },
  } = useContext(AppContext);
  
  const navigate = useNavigate();
  const location = useLocation();

  const isOwnerUser = appState.userId === appState.ownerId;

  const params = new URLSearchParams(window.location.search);

  const [selectedHotels, setSelectedHotels] = useState([]);

  useEffect(() => {
    if (params.get('registerPaymentMethod')) {
      const registerPaymentMethod = params.get('registerPaymentMethod');
      if (registerPaymentMethod === 'success') {
        paymentMethodConfigured(params.get('email'));
      } else {
        notification.warn({
          message: translate('register.registerKO'),
        });
      }
      params.delete('registerPaymentMethod');
      params.delete('email');

      navigate(location.pathname, {
        state: {
          registerPaymentMethod: params.toString(),
          email: params.toString(),
        },
      });
    } else {
      getPaymentMethods(appState.ownerId);
    }
  }, []);

  function paymentMethodConfigured(email) {
    paymentMethodConfiguredRequest({
      email,
      lang: appState.currentLanguage?.id,
    })
      .then(_data => {
        notification.success({
          message: translate('paymentMethods.addedSuccess'),
        });
        setTimeout(() => {
          getPaymentMethods(appState.ownerId);
        }, 1000);
      })
      .catch(error => {
        notification.error({
          message: error?.response?.data?.message,
        });
      });
  }

  return (
    <DefaultLayout>
      <ContentBox title={translate('user.accountDetailTitle')}>
        <AccountOwnerDetail userId={appState.ownerId}/>
      </ContentBox>
      {isOwnerUser && (
        <ContentBox title={translate('user.changePasswordTitle')}>
          <ChangePasswordForm />
        </ContentBox>
      )}
      <ContentBox title={translate('layout.paymentMethods')}>
        <PaymentMethods paymentMethod={appState.paymentMethods} userId={appState.ownerId} />
      </ContentBox>
      <ContentBox title={translate('accountDetail.billing')} noPadding>
        <span>
          <strong>{translate('hotelSelector.info')}</strong>
        </span>
        <NewHotelSelector
          enableAllHotels={true}
          mode={appState.superUser ? "multiple" : "single"} // multiple for superUsers
          onHotelSelected={setSelectedHotels}
          autoSelect={true}
        />
        <div style={{ height: 16 }} />
        <AccountFunctionalities selectedHotel={selectedHotels} />
      </ContentBox>
    </DefaultLayout>
  );
}
